// Country to language mapping
const countryToLanguage: Record<string, string> = {
  // English speaking countries
  'US': 'en', 'GB': 'en', 'CA': 'en', 'AU': 'en', 'NZ': 'en', 'IE': 'en',
  // German speaking countries
  'DE': 'de', 'AT': 'de',
  // French speaking countries
  'FR': 'fr', 'BE': 'fr', 'LU': 'fr', 'MC': 'fr', 'CH': 'fr',
  // Spanish speaking countries
  'ES': 'es', 'MX': 'es', 'AR': 'es', 'CO': 'es', 'PE': 'es', 'VE': 'es',
  'CL': 'es', 'EC': 'es', 'BO': 'es', 'PY': 'es', 'UY': 'es', 'CR': 'es',
  'PA': 'es', 'HN': 'es', 'GT': 'es', 'SV': 'es', 'NI': 'es', 'DO': 'es',
  'CU': 'es', 'PR': 'es',
  // Hindi speaking countries
  'IN': 'hi',
  // Indonesian speaking countries
  'ID': 'id',
  // Portuguese speaking countries
  'BR': 'pt', 'PT': 'pt', 'AO': 'pt', 'MZ': 'pt',
};

// Supported languages
const supportedLanguages = ['en', 'de', 'es', 'hi', 'id', 'pt', 'fr'];

export const detectCountryLanguage = async (): Promise<string | null> => {
  try {
    // Use a free IP geolocation service
    const response = await fetch('https://ipapi.co/json/', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Geolocation service unavailable');
    }

    const data = await response.json();
    const countryCode = data.country_code;

    if (countryCode && countryToLanguage[countryCode]) {
      const language = countryToLanguage[countryCode];
      return supportedLanguages.includes(language) ? language : null;
    }

    return null;
  } catch (error) {
    console.warn('Failed to detect country language:', error);
    return null;
  }
};